import signupLead from 'Enums/signupLead'
import { SignupUser, ApiSignupUser, SignupCompany, ApiSignupCompany } from 'Types'

const matchDigits = /\D+/g

export const formatSignupUser = (model: SignupUser): ApiSignupUser => {
  const modelAddress = model.address

  return {
    name: model.name,
    occupation: model.occupation,
    otherOccupation: model.otherOccupation,
    leadFrom: signupLead.coteibem,
    email: model.email,
    password: model.password,
    address: {
      description: modelAddress.description,
      street: modelAddress.street,
      streetNumber: modelAddress.streetNumber,
      complementary: modelAddress.streetDetails,
      neighborhood: modelAddress.neighborhood,
      zipCode: modelAddress.zipcode.replace(matchDigits, ''),
      addressType: modelAddress.type,
      cityId: modelAddress.cityId,
      isMain: true,
    }
  }
}

export const formatSignupCompany = (model: SignupCompany): ApiSignupCompany => {
  const modelAddress = model.address
  const modelPhone = model.phone
  const modelUser = model.user

  return {
    fancyName: model.name,
    cnpjcpf: model.registry.replace(matchDigits, ''),
    leadFrom: model.leadFrom || signupLead.coteibem,
    preSelectedPlan: model.planId,
    preSelectedPeriod: model.periodId,
    address: {
      description: model.name,
      street: model.address.street,
      streetNumber: model.address.streetNumber,
      complementary: model.address.streetDetails,
      neighborhood: model.address.neighborhood,
      zipCode: modelAddress.zipcode.replace(matchDigits, ''),
      addressType: null,
      cityId: model.address.cityId,
    },
    user: {
      name: modelUser.name,
      occupation: modelUser.occupation,
      otherOccupation: modelUser.otherOccupation,
      email: modelUser.email,
      password: modelUser.password,
    },
    phone: {
      ddd: modelPhone.ddd,
      number: modelPhone.number.replace(matchDigits, ''),
    }
  }
}

export default {
  formatSignupUser,
  formatSignupCompany,
}

